import { render } from "./VersionModal.vue?vue&type=template&id=43d3204a&scoped=true"
import script from "./VersionModal.vue?vue&type=script&lang=js"
export * from "./VersionModal.vue?vue&type=script&lang=js"

import "./VersionModal.vue?vue&type=style&index=0&id=43d3204a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d3204a"]])

export default __exports__